var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { SecurityAlertItem, SecurityAlertItemDescription, SecurityAlertItemTitle, SecurityAlertList, SecurityAlertTagLine } from './subcomponents';
import { SECURITY_ALERTS } from '../../../const/alertsConfig';
var SecurityAlerts = function () {
    var t = useTranslation().t;
    return (_jsxs("div", __assign({ "data-test": "SecurityAlertWrapper" }, { children: [_jsx(SecurityAlertTagLine, { children: t('alertsCategoriesSubtitle.securityAlerts') }), _jsx(SecurityAlertList, __assign({ "data-test": "SecurityAlertList" }, { children: SECURITY_ALERTS.map(function (securityAlertName) { return (_jsxs(SecurityAlertItem, { children: [_jsx(SecurityAlertItemTitle, { children: t("alertsTitle.".concat(securityAlertName)) }), _jsx(SecurityAlertItemDescription, { children: t("alertsSubTitle.".concat(securityAlertName)) })] }, securityAlertName)); }) }))] })));
};
export default SecurityAlerts;
